import React from "react";
import { Link } from "react-router-dom";
import ContentLoader from "../../Static/contentLoader";
import PaypalExpressBtn from "react-paypal-express-checkout";
import { withToastManager } from "react-toast-notifications";
import ToastDemo from "../../Helper/toaster";
import api from "../../../Environment";
import Helper from "../../Helper/helper";
import configuration from "react-global-configuration";
import { translate, t } from "react-multi-lang";
import {
  formatMoneyDisplay,
  isPaypalCheckoutVisible,
  moneyNumber,
  paymentModeCheckedMap,
  PAYPAL_CHECKOUT_BUTTON_STYLE,
} from "./checkoutPaymentHelpers";
import "./CheckoutPayment.css";

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = () => {
      resolve(true)
    }
    script.onerror = () => {
      resolve(false)
    }
    document.body.appendChild(script)
  })
}

class PayPerView extends Helper {
  state = {
    loadingFirst: true,
    data: {},
    promoCode: null,
    loadingPromoCode: true,
    paymentMode: "card",
    loadingContent: null,
    buttonDisable: false,
    loadingContentCard: null,
    buttonDisableCard: false,
    referralData: null,
    loadingReferral: true,
    pay_amount: 0,
    freePayPerView: false,
  };
  componentDidMount() {
    if (this.props.location.state) {
      this.setState({ loadingFirst: false });
    } else {
      window.location = "/home";
    }

    this.setState({
      pay_amount: this.props.location.state.videoDetailsFirst.ppv_amount,
      freePayPerView:
        this.props.location.state.videoDetailsFirst.ppv_amount <= 0
          ? true
          : false,
    });

    this.checkReferralInvoice();
  }

  checkReferralInvoice = (event) => {
    let inputData = {
      amount: this.props.location.state.videoDetailsFirst.ppv_amount,
    };
    api
      .postMethod("invoice_referral_amount", inputData)
      .then((response) => {
        // console.log(response.data);
        if (response.data.success) {
          if (response.data.data.pay_amount <= 0) {
            // Hide promocode section
            // Enable subscribe now button
            this.setState({
              freePayPerView: true,
            });
          }

          this.setState({
            referralData: response.data.data,
            pay_amount: response.data.data.pay_amount,
            loadingReferral: false,
          });
        } else {
          ToastDemo(
            this.props.toastManager,
            response.data.error_messages,
            "error"
          );
          this.setState({
            loadingContent: null,
            buttonDisable: false,
          });
        }
      })
      .catch((error) => {
        // ToastDemo(this.props.toastManager, error, "error");
        // this.setState({ loadingContent: null, buttonDisable: false });
      });
  };

  handlePromoCode = (event) => {
    event.preventDefault();
    this.setState({
      loadingContent: this.props.t("button_loading"),
      buttonDisable: true,
    });
    let inputData = {
      coupon_code: this.state.data.coupon_code,
      admin_video_id: this.props.location.state.videoDetailsFirst
        .admin_video_id,
    };
    api
      .postMethod("apply/coupon/ppv", inputData)
      .then((response) => {
        if (response.data.success) {
          ToastDemo(
            this.props.toastManager,
            this.props.t("promo_code_applied_success"),
            "success"
          );
          this.setState({
            loadingContent: null,
            loadingPromoCode: false,
            promoCode: response.data.data,
            buttonDisable: false,
            pay_amount: response.data.data.remaining_amount,
          });
        } else {
          ToastDemo(
            this.props.toastManager,
            response.data.error_messages,
            "error"
          );
          this.setState({
            loadingContent: null,
            buttonDisable: false,
          });
        }
      })
      .catch((error) => {
        ToastDemo(this.props.toastManager, error, "error");
        this.setState({ loadingContent: null, buttonDisable: false });
      });
  };

  handlePromoCodeCancel = (event) => {
    event.preventDefault();
    this.setState({ promoCode: null, loadingPromoCode: true });
    ToastDemo(
      this.props.toastManager,
      this.props.t("promo_code_removed"),
      "error"
    );
  };

  handleChangePayment = ({ currentTarget: input }) => {
    this.setState({ paymentMode: input.value });
  };
  handlePayment = (event) => {
    event.preventDefault();
    this.setState({
      loadingContentCard: this.props.t("button_loading"),
      buttonDisableCard: true,
    });
    let inputData;
    if (this.state.promoCode == null) {
      inputData = {
        admin_video_id: this.props.location.state.videoDetailsFirst
          .admin_video_id,
        payment_mode: this.state.paymentMode,
      };
    } else {
      inputData = {
        coupon_code: this.state.data.coupon_code,

        admin_video_id: this.props.location.state.videoDetailsFirst
          .admin_video_id,
        payment_mode: this.state.paymentMode,
      };
    }
    if(this.state.paymentMode == "razorpay") {
      this.displayRazorpay(inputData);
    } else if (this.state.paymentMode == "paystack") {
      this.paymentPayStackApiCall(inputData);
    } else {
      this.paymentApiCall(inputData);
    }
  };

  displayRazorpay = async (inputData) => {

    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')

    if (!res) {
        alert('Razorpay SDK failed to load. Are you online?')
        return
    }

    const data = await api.postMethod("ppv_razorpay_create_order", inputData).then(res => res.data);
    if (data.success) {
      const options = {
          key: configuration.get("configData.RAZOR_KEY"),
          currency: data.data.currency,
          amount: data.data.amount.toString(),
          order_id: data.data.id,
          name: 'Subscription Payment',
          description: 'Subscription Payment',
          handler: async (response) => {
              try {
                  const payment_id = response.razorpay_payment_id;
                  inputData = { ...inputData, payment_id }
                  this.paymentApiCall(inputData);
              } catch (err) {
                  ToastDemo(
                      this.props.toastManager,
                      err && err.message ? err.message : "Payment error",
                      "error"
                  );
              }
          }
      }
      const paymentObject = new window.Razorpay(options)
      paymentObject.open()
    } else {
      ToastDemo(
          this.props.toastManager,
          data.error,
          "error"
      );
    }
  }

  paymentApiCall = (inputData) => {
    api
      .postMethod("v4/ppv_payment", inputData)
      .then((response) => {
        if (response.data.success) {
          ToastDemo(this.props.toastManager, response.data.message, "success");
          this.setState({
            loadingContentCard: null,
            buttonDisableCard: false,
          });
          this.setState({
            loadingContentCard: null,
            buttonDisableCard: false,
          });
          this.props.history.push(
            `/video/${this.props.location.state.videoDetailsFirst.admin_video_id}`,
            this.props.location.state
          );
        } else {
          ToastDemo(
            this.props.toastManager,
            response.data.error_messages,
            "error"
          );
          this.setState({
            loadingContentCard: null,
            buttonDisableCard: false,
          });
        }
      })
      .catch((error) => {
        ToastDemo(this.props.toastManager, error, "error");
        this.setState({
          loadingContentCard: null,
          buttonDisableCard: false,
        });
      });
  };
  paymentPayStackApiCall = (inputData) => {
    api
      .postMethod("ppv_payment_by_paystack", inputData)
      .then((response) => {
        if (response.data.success) {
          ToastDemo(this.props.toastManager, response.data.message, "success");
          this.setState({
            loadingContentCard: null,
            buttonDisableCard: false,
          });
          this.setState({
            loadingContentCard: null,
            buttonDisableCard: false,
          });
          if (response.data.data.authorization_url) {
            window.location.href = response.data.data.authorization_url;
          } else {
            this.props.history.push(
              `/video/${this.props.location.state.videoDetailsFirst.admin_video_id}`,
              this.props.location.state
            );
          }
        } else {
          ToastDemo(
            this.props.toastManager,
            response.data.error_messages,
            "error"
          );
          this.setState({
            loadingContentCard: null,
            buttonDisableCard: false,
          });
        }
      })
      .catch((error) => {
        ToastDemo(this.props.toastManager, error, "error");
        this.setState({
          loadingContentCard: null,
          buttonDisableCard: false,
        });
      });
  };
  render() {
    var billingImg = {
      backgroundImage: "url(assets/img/billing.jpg)",
    };
    if (this.state.loadingFirst) {
      return <ContentLoader />;
    } else {
      const { videoDetailsFirst } = this.props.location.state;
      const {
        data,
        loadingPromoCode,
        promoCode,
        paymentMode,
        freePayPerView,
      } = this.state;

      const onSuccess = (payment) => {
        // Congratulation, it came here means everything's fine!

        let inputData;
        if (this.state.promoCode == null) {
          inputData = {
            admin_video_id: this.props.location.state.videoDetailsFirst
              .admin_video_id,
            payment_mode: this.state.paymentMode,
            payment_id: payment.paymentID,
          };
        } else {
          inputData = {
            coupon_code: this.state.data.coupon_code,

            admin_video_id: this.props.location.state.videoDetailsFirst
              .admin_video_id,
            payment_mode: this.state.paymentMode,
            payment_id: payment.paymentID,
          };
        }
        this.paymentApiCall(inputData);

        // You can bind the "payment" object's value to your state or props or whatever here, please see below for sample returned data
      };

      const onCancel = (data) => {
        // User pressed "cancel" or close Paypal's popup!
        // You can bind the "data" object's value to your state or props or whatever here, please see below for sample returned data
      };

      const onError = (err) => {
        ToastDemo(
          this.props.toastManager,
          err && err.message ? err.message : "PayPal error",
          "error"
        );
      };

      const modeChecked = paymentModeCheckedMap(paymentMode);
      const paypalVisible = isPaypalCheckoutVisible(
        configuration.get("configData")
      );

      let env = configuration.get("configData.PAYPAL_MODE"); // you can set here to 'production' for production
      let currency = "USD"; // or you can set this value from your props or state
      let total = moneyNumber(this.state.pay_amount); // PayPal total — two-decimal precision

      const client = {
        sandbox: configuration.get("configData.PAYPAL_ID"),
        production: configuration.get("configData.PAYPAL_ID"),
      };

      return (
        <div>
          <div className="main padding-top-md">
            <div className="top-bottom-spacing">
              <div className="row">
                <div className="col-sm-10 col-md-11 col-lg-9 col-xl-8 auto-margin">
                  <div className="row m-0">
                    <div className="col-sm-12 col-md-5 col-lg-5 col-xl-5 p-0">
                      <div className="billing-img" style={billingImg}>
                        <div className="billing-img-overlay">
                          {/* <div className="display-inline">
                                                        <div className="icon-left">
                                                        <h5 className="billing-head">
                                                            <i className="fas fa-th-large" />
                                                        </h5>
                                                        </div>
                                                        <div className="content-right">
                                                        <h5 className="billing-head mb-3">category</h5>
                                                        <p className="m-0">TV series</p>
                                                        </div>
                                                    </div>
                                                    <div className="clearfix" />
                                                    <p className="grey-line" />
                                                    <div className="display-inline">
                                                        <div className="icon-left">
                                                        <h5 className="billing-head">
                                                            <i className="fas fa-th-large" />
                                                        </h5>
                                                        </div>
                                                        <div className="content-right">
                                                        <h5 className="billing-head mb-3">
                                                            sub category
                                                        </h5>
                                                        <p className="m-0">english series</p>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="clearfix" />
                                                    <p className="grey-line" /> */}

                          <div className="display-inline">
                            <div className="icon-left">
                              <h5 className="billing-head">
                                <i className="far fa-file-alt" />
                              </h5>
                            </div>
                            <div className="content-right">
                              <h5 className="billing-head mb-3">
                                {t("title")}
                              </h5>
                              <p className="m-0">{videoDetailsFirst.title}</p>
                            </div>
                          </div>
                          <div className="clearfix" />
                          <p className="grey-line" />
                          <div className="display-inline">
                            <div className="icon-left">
                              <h5 className="billing-head">
                                <i className="fas fa-user" />
                              </h5>
                            </div>
                            <div className="content-right">
                              <h5 className="billing-head mb-3">
                                {t("user_type")}
                              </h5>
                              <p className="m-0">
                                {videoDetailsFirst.type_of_user == 1
                                  ? "Normal User"
                                  : videoDetailsFirst.type_of_user == 2
                                  ? "Paid User"
                                  : "Both User"}
                              </p>
                            </div>
                          </div>
                          <div className="clearfix" />
                          <p className="grey-line" />
                          <div className="display-inline">
                            <div className="icon-left">
                              <h5 className="billing-head">
                                <i className="far fa-hand-point-up" />
                              </h5>
                            </div>
                            <div className="content-right">
                              <h5 className="billing-head mb-3">
                                {t("subscription_type")}
                              </h5>
                              <p className="m-0">
                                {videoDetailsFirst.type_of_subscription == 1
                                  ? "one type payment"
                                  : "recurring Payment"}
                              </p>
                            </div>
                          </div>
                          <div className="clearfix" />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-7 col-lg-7 col-xl-7 p-0">
                      <div className="billing-content-sec">
                        <h4 className="billing-head">
                          <i className="far fa-credit-card" />
                          {t("pay_per_view")}
                        </h4>
                        <p className="grey-line" />
                        <div className="">
                          <h5 className="">{t("amount")}</h5>
                          <p className="grey-clr pay-perview-text">
                            {t("pay_for_video_text")}
                          </p>
                        </div>
                        {/* <!-- table1 --> */}
                        <div className="table-responsive">
                          <table className="table white-bg m-0">
                            <tbody>
                              <tr className="table-secondary">
                                <td>{t("amount")}</td>
                                <td>
                                  {formatMoneyDisplay(
                                    videoDetailsFirst.currency,
                                    videoDetailsFirst.ppv_amount
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td>{t("promo_code_amount")}</td>
                                <td>
                                  {formatMoneyDisplay(
                                    videoDetailsFirst.currency,
                                    loadingPromoCode
                                      ? 0
                                      : promoCode.coupon_amount
                                  )}
                                </td>
                              </tr>
                              {this.state.loadingReferral == false ? (
                                <tr>
                                  <td>{t("referral_amount_applied")}</td>
                                  <td>
                                    {
                                      this.state.referralData
                                        .referral_amount_formatted
                                    }
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}
                              <tr className="table-secondary">
                                <td>{t("total")}</td>
                                <td>
                                  {formatMoneyDisplay(
                                    videoDetailsFirst.currency,
                                    this.state.pay_amount
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        {/* <!-- table --> */}

                        {/* <!-- coupon --> */}
                        {freePayPerView == false ? (
                          <div className="mt-4">
                            <h5 className="capitalize">{t("have_a_coupon")}</h5>
                            <form
                              className="auth-form"
                              onSubmit={this.handlePromoCode}
                            >
                              <div className="form-group mt-3">
                                <div className="input-group mb-3 mt-1">
                                  <input
                                    type="text"
                                    className="form-control m-0 mb-0"
                                    placeholder={t("promocode")}
                                    name="coupon_code"
                                    value={data.coupon_code}
                                    onChange={this.handleChange}
                                  />
                                  <div className="input-group-append">
                                    <button
                                      className="btn btn-danger"
                                      type="submit"
                                    >
                                      {this.state.loadingContent != null
                                        ? this.state.loadingContent
                                        : t("send")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                            {loadingPromoCode ? (
                              ""
                            ) : (
                              <p className="capitalize">
                                Promo code applied - {promoCode.coupon_code} for{" "}
                                {promoCode.original_coupon_amount} -{" "}
                                <Link
                                  to="#"
                                  className="btn-danger"
                                  onClick={this.handlePromoCodeCancel}
                                >
                                  {t("cancel")}
                                </Link>
                              </p>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                        {/* <!-- coupon --> */}

                        {/* <!-- payment option --> */}
                        {freePayPerView == false ? (
                          <div className="mt-4 checkout-payment-methods">
                            <h5 className="capitalize">
                              {t("choose_payment_option")}
                            </h5>
                            <form
                              className="mt-3"
                              onSubmit={(e) => e.preventDefault()}
                            >
                              <div className="checkout-payment-methods__choices">
                              {paypalVisible &&
                              configuration.get("configData.PAYPAL_ID") ? (
                                <div className="checkout-payment-methods__choice form-check-inline">
                                  <input
                                    type="radio"
                                    id="paypal"
                                    name="payment_mode"
                                    value="paypal"
                                    checked={!!modeChecked.paypal}
                                    onChange={this.handleChangePayment}
                                  />
                                  <label htmlFor="paypal">{t("paypal")}</label>
                                </div>
                              ) : (
                                ""
                              )}
                              {configuration.get("configData.is_razorpay_enabled") == 1 ? (
                                <div className="checkout-payment-methods__choice form-check-inline">
                                  <input
                                      type="radio"
                                      id="razorpay"
                                      name="payment_mode"
                                      value="razorpay"
                                      checked={!!modeChecked.razorpay}
                                      onChange={
                                          this
                                              .handleChangePayment
                                      }
                                  />
                                  <label htmlFor="razorpay">
                                      {t(
                                          "razorpay"
                                      )}
                                  </label>
                                </div>
                                ) : (
                                  ""
                              )}
                              {configuration.get("configData.is_paystack_enabled") == 1 ? (
                                <div className="checkout-payment-methods__choice form-check-inline">
                                  <input
                                      type="radio"
                                      id="paystack"
                                      name="payment_mode"
                                      value="paystack"
                                      checked={!!modeChecked.paystack}
                                      onChange={
                                          this
                                              .handleChangePayment
                                      }
                                  />
                                  <label htmlFor="paystack">
                                      {t(
                                          "paystack"
                                      )}
                                  </label>
                                </div>
                                ) : (
                                  ""
                              )}

                              <div className="checkout-payment-methods__choice form-check-inline">
                                <input
                                  type="radio"
                                  id="card"
                                  name="payment_mode"
                                  value="card"
                                  checked={!!modeChecked.card}
                                  onChange={this.handleChangePayment}
                                />
                                <label htmlFor="card">
                                  {t("card_payment")}
                                </label>
                              </div>
                              <Link
                                to="/add-card"
                                className="btn btn-link checkout-payment-methods__add-card p-0"
                              >
                                {t("add_card")}
                              </Link>
                              </div>
                              <div className="checkout-payment-methods__actions text-right mb-3 mt-3">
                                {paymentMode == "card" ? (
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={this.handlePayment}
                                    disabled={this.state.buttonDisableCard}
                                  >
                                    {this.state.loadingContentCard != null
                                      ? this.state.loadingContentCard
                                      : t("pay_now_using_card")}
                                  </button>
                                ) : paymentMode === "paypal" && paypalVisible ? (
                                  <div className="checkout-payment-methods__paypal">
                                    <PaypalExpressBtn
                                      env={env}
                                      client={client}
                                      currency={currency}
                                      total={total}
                                      style={PAYPAL_CHECKOUT_BUTTON_STYLE}
                                      onError={onError}
                                      onSuccess={onSuccess}
                                      onCancel={onCancel}
                                    />
                                  </div>
                                ) : (
                                  <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={
                                          this
                                              .handlePayment
                                      }
                                      disabled={
                                          this.state
                                              .buttonDisableCard
                                      }
                                  >
                                      {t("pay_now")}
                                  </button> 
                                )}
                              </div>
                            </form>
                          </div>
                        ) : (
                          <div className="mt-4">
                            <div className="text-right mb-3 mt-3">
                              <button
                                className="btn btn-danger"
                                onClick={this.handlePayment}
                                disabled={this.state.buttonDisableCard}
                              >
                                {t("watch_now_free")}
                              </button>
                            </div>
                          </div>
                        )}
                        {/* <!-- payment option --> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default withToastManager(translate(PayPerView));
